import networkManager from "../NetworkManager/index";

export default {
  getFeedback(formURL) {
    return networkManager.getRequest(
      "/feedbackWithNBAAttainment/getFeedbackByFormUrl",
      { formURL }
    );
  },

  getInstituteBranding(instituteId) {
    return networkManager.getRequest("/institute/getInstituteBranding", {
      instituteId,
    });
  },

  getSemesterDetails(instituteId, semId) {
    return networkManager.postRequest("/semester/getSemestersBySemId", {
      instituteId,
      semId,
    });
  },

  getBatchName(params) {
    return networkManager.postRequest(
      "/setup/batch/getBatchNameByCourseYear",
      params
    );
  },

  getDivisionAndFacultiesForSubject(params) {
    return networkManager.getRequest(
      "/subject/getDivisionAndFacultiesForSubject",
      params
    );
  },

  login(email) {
    return networkManager.getRequest("/auth/getUserAuthenticationByEmail", {
      email,
    });
  },

  getUsers(uIds) {
    return networkManager.postRequest("/users/getUsers", { uIds });
  },

  getAllocatedSubjects(params) {
    return networkManager.getRequest(
      "/semesterUser/getSubjectDetailsByUId",
      params
    );
  },

  getAllocatedSubjectsWithOtherDepartments(params) {
    return networkManager.getRequest(
      "/semesterUser/getAllocatedSubjectsWithOtherDepartments",
      params
    );
  },

  getFeedbackResponseByUId(params) {
    return networkManager.getRequest(
      "/feedbacks/getFeedbackResponseByUId",
      params
    );
  },

  submitFeedback(feedbackFormId, studentResponse) {
    return networkManager.postRequest("/feedbacks/createSingleFeedbackResponse", {
      feedbackFormId,
      studentResponse,
    });
  },
};
